var React = require('react');

function ArrowLgInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 21H561","stroke":"black","key":0}),React.createElement("path",{"d":"M540.799 1L560.598 20.7989L540.799 40.5977","stroke":"black","key":1})]);
}

ArrowLgInline.defaultProps = {"viewBox":"0 0 562 41","fill":"none"};

module.exports = ArrowLgInline;

ArrowLgInline.default = ArrowLgInline;
